import { Component } from '@angular/core';
import { FormFieldComponent } from '../form-field/form-field.component';
import { Media } from '@models/media/media.model';
import { NgxDropzoneChangeEvent } from 'ngx-dropzone';
import { readFile } from '@functions/files';

@Component({
  selector: 'app-form-field-text',
  templateUrl: './form-file.component.html',
  styleUrls: ['../../../mig-form.component.scss'],
})
export class FormFileComponent extends FormFieldComponent {
  mediaId: string | undefined = undefined;
  firstMedia: Media = {
    url: null,
    file: null,
    reference: 'firstMedia',
  };

  onSelect(event: NgxDropzoneChangeEvent, media: Media) {
    media.file = event.addedFiles[0];
    if (media.file) {
      readFile(media.file).then(() => {
        media.url = null;
        const params = {
          file: media.file,
          source: 'UNKNOWN',
        };
        this.api
          .form<Media[]>(`media/upload-file`, params)
          .subscribe(response => {
            this.mediaId = response[0].id;
          });
      });
    }
  }

  onRemoveLogo(media: Media) {
    media.file = null;
  }
}
